// extracted by mini-css-extract-plugin
module.exports = {"formHint":"shipping-info_formHint__3FVpQ"};